export const clientSecretSelector = state => state.configuration.stripe.clientSecret;
export const pubKeySelector = state => state.configuration.stripe.pubKey;
export const stripeSetupIntentSelector = state => state.configuration.stripe.setupIntentId;
